import { render } from "./App.vue?vue&type=template&id=9b485966&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=9b485966&lang=scss"

import exportComponent from "W:\\01_WORK\\01_Web\\lin.com\\Vue\\account\\node_modules\\_vue-loader@17.0.1@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__